import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgNo = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "m.31 14.719 2.1-2.799L.313 9.268a12.02 12.02 0 0 1 6.091-7.886l1.392 1.126L10.89.05q.547-.051 1.11-.051c5.705.001 10.48 3.983 11.7 9.32l-1.842 2.728 1.839 2.647C22.474 20.024 17.7 24 12 24q-.563 0-1.114-.051l-3.119-2.326-1.316 1.02A12.02 12.02 0 0 1 .31 14.718Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "M7.432.9c-.984.405-1.903.938-2.735 1.577v6.396H.41a12 12 0 0 0-.325 1.682l1.067 1.431-1.066 1.465q.104.864.327 1.685h4.283v6.387a12 12 0 0 0 2.652 1.543l.348-.299 1.098.8q1.045.29 2.16.388v-8.824h12.632q.222-.821.326-1.684l-1.066-1.461 1.067-1.431a12 12 0 0 0-.326-1.682H10.954V.045a12 12 0 0 0-2.134.38l-1.016.761z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#0052B4",
      d: "M9.39.285a12 12 0 0 0-3.128 1.173v8.981H.102a12 12 0 0 0 0 3.127h6.162v8.976c.969.529 2.019.927 3.126 1.173v-10.15H23.9a12 12 0 0 0 0-3.126H9.39z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgNo;